import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { AppRoutingModule } from '../../app-routing.module';
import { GlobalAlertsModule } from '../../features/global-alerts/global-alerts.module';
import { ToolbarModule } from '../../features/toolbar/toolbar.module';
import { PageContentComponent } from './page-content.component';

@NgModule({
  declarations: [PageContentComponent],
  imports: [CommonModule, GalaxyPageModule, ToolbarModule, AppRoutingModule, GlobalAlertsModule],
  exports: [PageContentComponent],
})
export class PageContentModule {}
